// Import the functions you need from the SDKs you need
import { getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getMessaging } from 'firebase/messaging';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyDLpypgo8L9f4XRbabZniDTZLq-HQ0h9NI',
  authDomain: 'offer-app-react.firebaseapp.com',
  projectId: 'offer-app-react',
  storageBucket: 'offer-app-react.firebasestorage.app',
  messagingSenderId: '209919722422',
  appId: '1:209919722422:web:6ccb1e32b73020e5dbb717',
  measurementId: 'G-YGPY2XZFHF',
};

let app;
if (!getApps().length) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0];
}

export const auth = getAuth(app);
export const db = getFirestore(app);

// Initialize messaging with service worker
let messaging;
try {
  messaging = getMessaging(app);

  // Register service worker for Firebase messaging
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
      .then((registration) => {
        console.log('Firebase SW registered:', registration);

        // Request notification permissions and get token
        if (Notification.permission === 'default') {
          Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
              // Import getToken here to avoid circular imports
              import('firebase/messaging').then(({ getToken }) => {
                getToken(messaging, { serviceWorkerRegistration: registration })
                  .then((token) => {
                    if (token) {
                      console.log('Ready to work');
                    }
                  })
                  .catch((error) => {
                    console.error('Error getting token:', error);
                  });
              });
            }
          });
        } else if (Notification.permission === 'granted') {
          // Import getToken here to avoid circular imports
          import('firebase/messaging').then(({ getToken }) => {
            getToken(messaging, { serviceWorkerRegistration: registration })
              .then((token) => {
                if (token) {
                  console.log('Ready to work');
                }
              })
              .catch((error) => {
                console.error('Error getting token:', error);
              });
          });
        }
      })
      .catch((error) => {
        console.error('Firebase SW registration failed:', error);
      });
  }
} catch (error) {
  console.error('Error initializing messaging:', error);
  messaging = null;
}

export { messaging };
export default app;